import React from "react";

const Modal = ({ onClose, children, contentStyle, contentClassName }) => {
  // IMPORTANT: In production builds, React may minify component names, so
  // child.type.name is unreliable. Compare by component type reference instead.
  const allowedTypes = [Modal.Header, Modal.Body, Modal.Footer];
  const contentClasses = ["modal--content", contentClassName].filter(Boolean).join(" ");
  const filteredChildren = React.Children.toArray(children).filter(
    (child) => child && child.type && allowedTypes.includes(child.type)
  );

  return (
    <div className="modal">
      <div className={contentClasses} style={contentStyle}>
        {filteredChildren}
      </div>
    </div>
  );
};
// Como inyectar onClose en el header para que lo mande el modal
const Header = (props) => {
  return (
    <div className="modal--header">
      {props.closeButton && (
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            props.onClose();
          }}
        >
          <i className="fas fa-arrow-left" />
        </a>
      )}
      {props.children}
    </div>
  );
};
Modal.Header = Header;

const Body = (props) => <div className="modal--body">{props.children}</div>;
Modal.Body = Body;

const Footer = (props) => <div className="modal--footer">{props.children}</div>;
Modal.Footer = Footer;

export default Modal;
